import { gql } from 'graphql-request'

export const SET_DEVICE_TOKEN = gql`
  mutation SetDeviceToken($setDeviceTokenInput: SetDeviceTokenInput!) {
    setDeviceToken(setDeviceTokenInput: $setDeviceTokenInput) {
      message
    }
  }
`
